import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-analyticscreditbureaudetails',
  templateUrl: './analyticscreditbureaudetails.component.html',
  styleUrls: ['./analyticscreditbureaudetails.component.css']
})
export class AnalyticscreditbureaudetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
